import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import "../Styles/ServiceCards.css";
import LearnMoreButton from "../components/LearnMoreButton";

import circleBg from "../Images/Ellipse 5.png"; // local image

const SERVICES_URL =
  "https://raw.githubusercontent.com/DhotradSunnyDentalandOrthodonticClinics/website-services/main/Services.json";

const ServiceCards = ({ count }) => {
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch(SERVICES_URL)
      .then((res) => res.json())
      .then((data) => setServices(data))
      .catch((err) => console.error("Failed to load services", err));
  }, []);

  // ensures full rows of 3
  const validCount = Math.min(count - (count % 3), services.length);

  return (
    <section className="services-section">
      {services.slice(0, validCount).map((service) => (
        <div className="service-card" key={service.id}>
          <div className="icon-circle-image">
            {/* circle background (local) */}
            <img src={circleBg} alt="" className="circle-bg" />

            {/* service icon (REMOTE URL) */}
            <img
              src={service.icon}
              alt={service.title}
              className="smile-icon"
              loading="lazy"
            />
          </div>

          <h3>{service.title}</h3>
          <p>{service.description}</p>

          <LearnMoreButton
            onClick={() => navigate(`/services/${service.id}`)}
          />
        </div>
      ))}
    </section>
  );
};

ServiceCards.propTypes = {
  count: PropTypes.number.isRequired,
};

export default ServiceCards;
